/** @file shellMenuBindings: the keyboard routes to the context menu (the ContextMenu key and Shift+F10). */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

/** Both open the same menu for the current selection (`menuHandlers`); a keyboard needs no right button. */
export const shellMenuBindings: Binding[] = [
  { id: 'menu.context', keys: 'ContextMenu', context: 'global' },
  { id: 'menu.context.shiftF10', keys: 'Shift+F10', context: 'global' },
];
